export const PROFILE_CONFIG = {
  personal: {
    name: 'Ranju Gamage',
    role: 'Senior Software Engineer',
    email: 'ranju@ranjugamage.dev',
    location: 'Sri Lanka'
  },
  social: {
    github: 'https://github.com/RanjuLG',
    linkedin: 'https://linkedin.com/in/ranju-laksahan',
    twitter: ''
  },
  urls: {
    baseUrl: 'https://ranjugamage.dev'
  },
  seo: {
    siteName: 'Ranju Gamage - Senior Software Engineer'
  },
  availability: {
    status: true,
    title: 'Currently Available',
    message: 'Open to new opportunities and freelance projects'
  }
};
